import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { visibilityIcon } from '@/constants/images';

const CohortVisibilityLabel = ({ visibility }) => (
  <Label>
    <Icon name={visibilityIcon[visibility]} />
    <FormattedMessage id={`cohorts.visibility.${visibility}`} />
  </Label>
);

export default CohortVisibilityLabel;
